module.exports = __webpack_public_path__ + "static/media/Finnovex-Middle-East-2023.a2a393e1.png";